import React from "react";
import {
	BsInstagram,
	BsArrowLeftShort,
	BsArrowRightShort,
} from "react-icons/bs";
import { SubHeading } from "../../components";
import { images } from "../../constants";

import "./Gallery.css";

const Gallery = () => {
	const galleryImages = [
		images.gallery01,
		images.gallery03,
		images.gallery04,
		images.gallery02,
		images.gallery05,
		images.gallery06,
		images.gallery07,
	];
	const scrollRef = React.useRef(null);

	var insta = "https://instagram.com/_m.a.r.y.m.a.t.h.a_catering_/";

	const scroll = (direction) => {
		const { current } = scrollRef;

		if (direction === "left") {
			current.scrollLeft -= 300;
		} else {
			current.scrollLeft += 300;
		}
	};

	return (
		<div id="gallery" className="app__gallery app__bg flex_center">
			<div className="app__gallery-content">
				<SubHeading title="Instagram" />
				<p className="headtext__cormorant"> Photo Gallery </p>
				<p className="p__opensans" style={{ color: "#AAA", margin: "2rem" }}>
					Browse through a curated collection of stunning photographs,
					showcasing the magical moments we have crafted for our clients. <br />{" "}
					For more details, breathtaking pictures, and enticing event posters,
					visit our Instagram page.
				</p>
			</div>

			<div className="app__gallery-images">
				<div className="app__gallery-images_container" ref={scrollRef}>
					{galleryImages.map((image, index) => (
						<a href={insta}>
							<div
								className="app__gallery-images_card flex__center"
								key={`gallery_image-${index + 1}`}
							>
								<img src={image} loading="lazy" alt="gallery" />

								<BsInstagram className="gallery__image-icon" />
							</div>
						</a>
					))}
				</div>

				<div className="app__gallery-images_arrows ">
					<BsArrowLeftShort
						className="gallery__arrow-icon"
						onClick={() => scroll("left")}
					/>
					<BsArrowRightShort
						className="gallery__arrow-icon"
						onClick={() => scroll("right")}
					/>
				</div>
			</div>
		</div>
	);
};

export default Gallery;
